export { default } from './CamAdBlock';
